import React from 'react';
import { NavLink } from 'react-router-dom';
import { Bell, BookOpen, Bot, ChevronRight, ClipboardList, Flag, HeadphonesIcon, LayoutDashboard, Lightbulb, ListChecks, Megaphone, MessageSquare, Package, ShoppingCart, Sparkles, Star, Ticket, Users } from 'lucide-react';

/**
 * Waitlist and Ads both used the `Users` icon, which made three different
 * destinations in one group visually identical — the icons stopped
 * distinguishing anything and became decoration.
 */
const NAV = [
  {
    section: 'MAIN',
    items: [
      { label: 'Dashboard',     path: '/',             icon: LayoutDashboard },
    ]
  },
  {
    section: 'MANAGEMENT',
    items: [
      { label: 'Users',         path: '/users',        icon: Users },
      { label: 'Products',      path: '/products',     icon: Package },
      { label: 'Orders',        path: '/orders',       icon: ShoppingCart },
      { label: 'Discounts',     path: '/discounts',    icon: Ticket },
      { label: 'Community',     path: '/community',    icon: MessageSquare },
      { label: 'Reports',       path: '/reports',      icon: Flag },
      { label: 'Waitlist',      path: '/waitlist',     icon: ListChecks },
      { label: 'Ads',           path: '/ads',          icon: Megaphone },
    ]
  },
  {
    section: 'ENGAGEMENT',
    items: [
      { label: 'Notifications', path: '/notifications',icon: Bell },
      { label: 'Blogs',         path: '/blog',         icon: BookOpen },
      { label: 'Hair Tips',     path: '/hair-tips',    icon: Lightbulb },
      { label: 'Zora AI Data',  path: '/zora',         icon: Bot },
    ]
  },
  {
    section: 'SUPPORT',
    items: [
      { label: 'Reviews',       path: '/reviews',      icon: Star },
      { label: 'Contacts',      path: '/complaints',   icon: HeadphonesIcon },
      { label: 'Audit log',     path: '/audit',        icon: ClipboardList },
    ]
  },
];

export default function Sidebar() {
  return (
    <aside style={{
      width: 240,
      background: 'var(--sidebar-bg)',
      height: '100vh',
      position: 'fixed',
      top: 0, left: 0,
      boxShadow: '2px 0 12px rgba(0,0,0,0.06)',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100,
      overflowY: 'auto',
      borderRight: '1px solid rgba(231, 233, 242, 0.8)',
      backdropFilter: 'blur(18px)',
    }}>
      {/* Logo */}
      <div style={{
        padding: '20px 24px',
        borderBottom: '1px solid var(--border)',
        display: 'flex', alignItems: 'center', gap: 10,
      }}>
        {/* <div style={{
          width: 36, height: 36,
          background: 'linear-gradient(135deg, var(--primary), #8b7ffd)',
          borderRadius: 12,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 14px 26px rgba(108, 95, 252, 0.25)',
        }}>
          <Zap size={18} color="#fff" />
        </div>
        <div>
          <div style={{ fontWeight: 800, fontSize: 16, color: 'var(--text-primary)', letterSpacing: '-0.3px' }}>Zorax</div>
          <div style={{ fontSize: 10, color: 'var(--text-muted)', fontWeight: 600, letterSpacing: 1 }}>ADMIN PANEL</div>
        </div> */}
        <img src='/logo1.png' alt='Zorax' style={{width: 100}} />
      </div>

      {/* Nav */}
      <nav style={{ padding: '12px 0', flex: 1 }}>
        {NAV.map(group => (
          <div key={group.section} style={{ marginBottom: 8 }}>
            <div style={{
              fontSize: 10, fontWeight: 700,
              color: 'var(--text-light)',
              letterSpacing: 1.2,
              padding: '10px 24px 6px',
            }}>
              {group.section}
            </div>
            {group.items.map(item => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                style={({ isActive }) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '11px 14px',
                  margin: '1px 12px',
                  borderRadius: 12,
                  fontSize: 13,
                  fontWeight: isActive ? 750 : 600,
                  color: isActive ? 'var(--primary)' : 'var(--text-secondary)',
                  background: isActive ? 'var(--primary-light)' : 'transparent',
                  boxShadow: isActive ? 'inset 3px 0 0 var(--primary), 0 10px 22px rgba(108, 95, 252, 0.08)' : 'none',
                  transition: 'all 0.18s',
                  textDecoration: 'none',
                })}
              >
                {({ isActive }) => (
                  <>
                    <item.icon size={16} strokeWidth={isActive ? 2.5 : 2} />
                    <span style={{ flex: 1 }}>{item.label}</span>
                    {isActive && <ChevronRight size={13} />}
                  </>
                )}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div style={{ padding: 16 }}>
        <div style={{
          border: '1px solid rgba(108, 95, 252, 0.18)',
          borderRadius: 16,
          background: 'linear-gradient(135deg, var(--primary-light), #fff)',
          color: 'var(--text-secondary)',
          fontSize: 11,
          padding: 14,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--primary)', fontWeight: 800, marginBottom: 6 }}>
            <Sparkles size={14} />
            Admin cockpit
          </div>
          <div style={{ lineHeight: 1.5 }}>Zorax Admin v1.0</div>
        </div>
      </div>
    </aside>
  );
}
